/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePriceListProductPrice
 */
export interface UpdatePriceListProductPrice {
    /**
     * 
     * @type {string}
     * @memberof UpdatePriceListProductPrice
     */
    productId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePriceListProductPrice
     */
    price: number;
}

/**
 * Check if a given object implements the UpdatePriceListProductPrice interface.
 */
export function instanceOfUpdatePriceListProductPrice(value: object): value is UpdatePriceListProductPrice {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function UpdatePriceListProductPriceFromJSON(json: any): UpdatePriceListProductPrice {
    return UpdatePriceListProductPriceFromJSONTyped(json, false);
}

export function UpdatePriceListProductPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePriceListProductPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'price': json['price'],
    };
}

export function UpdatePriceListProductPriceToJSON(json: any): UpdatePriceListProductPrice {
    return UpdatePriceListProductPriceToJSONTyped(json, false);
}

export function UpdatePriceListProductPriceToJSONTyped(value?: UpdatePriceListProductPrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'price': value['price'],
    };
}

